/** Maximo de entradas por coleccion repetible. El backend valida el mismo tope. */
export const MAX_ENTRADAS = 10;

/** Tamano maximo por archivo adjunto, en bytes. */
export const MAX_FILE_BYTES = 2_000_000;

/** El mismo limite en MB, para interpolarlo en los mensajes al usuario. */
export const MAX_FILE_MB = MAX_FILE_BYTES / 1_000_000;

/**
 * Recorta una seleccion multiple al tope admitido.
 *
 * @param items Seleccion actual, posiblemente nula.
 * @returns Los primeros MAX_ENTRADAS elementos, o el valor original si no hay exceso.
 */
export const capSeleccion = <T>(items: T[] | null): T[] | null => (
  items && items.length > MAX_ENTRADAS ? items.slice(0, MAX_ENTRADAS) : items
);
